
/* 
    * 楼层计算  楼层转化中文
    * 参数  index ：楼层   数据类型：int
*/
export function getRoom(index) {
    let arr = [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
    ];
    if (index < 0) {
        return "地下室" + arr[Number(-index) - 1] + "层";
    } else if (index <= 10 && index > 0) {
        return arr[Number(index) - 1] + "层";
    }
}
/* 
    * 输入框只允许输入数字和一个小数点  注：此方法只允许type = "text"类型的输入框
    * caet代表类型不同类型 赋值不同的参数   num：输入框中的值
*/
export function inputCheck(caet = 0, num) {
    var str = num.target.value;
    var len1 = str.substr(0, 1);
    var len2 = str.substr(1, 1);
    //如果第一位是0，第二位不是点，就用数字把点替换掉
    if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
    }
    //第一位不能是.
    if (len1 == ".") {
        str = "";
    }
    //限制只能输入一个小数点
    if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1);
        if (str_.indexOf(".") != -1) {
            str = str.substr(
                0,
                str.indexOf(".") + str_.indexOf(".") + 1
            );
        }
    }
    //正则替换，保留数字和小数点
    str = str.replace(/[^\d^\.]+/g, "");
    //如果需要保留小数点后两位，则用下面公式
    str = str.replace(/\.\d\d$/, "");
    let data = {
        caet: caet,
        str: str
    }
    return data
}
/* 
    * 非频繁使用空间全选
    * 参数 index： 选中的是第几层   arrNoOftenTagList： 非频繁使用空间选中的数组
*/
export function getWrong(index, arrNoOftenTagList) {
    arrNoOftenTagList[index].openCheck = !arrNoOftenTagList[index].openCheck;
    arrNoOftenTagList.forEach((is, index) => {
        arrNoOftenTagList[index].tags.forEach((item) => {
            if (arrNoOftenTagList[index].openCheck) {
                is.checked.push({ id: item.id, number: item.number });
                item.openTags = true;
            } else {
                is.checked = [];
                item.openTags = false;
            }
        });
    });
    return arrNoOftenTagList
}
/* 
    * 编辑楼层 
    * arrEditFloorContent ：填充数据  oHouseTypeInfo：编辑楼层的数据
*/
export function editHouse(arrEditFloorContent, oHouseTypeInfo) {
    arrEditFloorContent.floor.forEach((it) => {
        it.content = [];
    });
    oHouseTypeInfo.tabList.forEach((item) => {
        arrEditFloorContent.floor.forEach((it) => {
            if (item.room === it.room) {
                let arrTags = [];
                item.content.forEach((calssItem) => {
                    arrTags = [...arrTags, ...calssItem.tags];
                });
                arrTags = JSON.parse(JSON.stringify(arrTags));
                it.content = tagsSortFun(arrTags);
            }
        });
    });
}
/* 
    * 非频繁空间单选空间
*/
export function noOpenSlect(info, index, item, tagIndex, arrNoOftenTagList) {
    arrNoOftenTagList[index].tags[tagIndex].openTags =
        !arrNoOftenTagList[index].tags[tagIndex].openTags;
    let arrTags = arrNoOftenTagList[index].tags.filter((it) => {
        return it.openTags == true;
    });
    if (arrNoOftenTagList[index].tags.length == arrTags.length) {
        arrNoOftenTagList[index].openCheck = true;
    }
    const active = info.checked.findIndex(
        (_) => _.id === item.id && _.number === item.number
    );
    if (~active) {
        info.checked.splice(active, 1);
    } else {
        info.checked.push({ id: item.id, number: item.number });
    }
}


/* 
    * 标签按sort排序，按id分类方法
*/
export function tagsSortFun(data) {
    let map = {},
        dest = [];
    data.forEach((item) => {
        if (!map[item.id]) {
            dest.push([item]);
            map[item.id] = item;
        } else {
            dest.forEach((destItem) => {
                const index = destItem.findIndex(
                    (_) => _.id === item.id
                );
                if (~index) {
                    destItem.push(item);
                }
            });
        }
    });
    console.log(data)
    dest.sort(function (a, b) {
        return Number(b[0].sort) - Number(a[0].sort);
    });
    return dest.reduce((prev, cur, index, arr) => {
        if (cur.length > 1) {
            cur.forEach((item, idx) => {
                item.isNumber = 1; // 多个同房间展示数字
                item.number = idx + 1; // 展示的数字
            });
        } else {
            cur.forEach((item, idx) => {
                item.isNumber = 0; // 多个同房间不展示数字
            });
        }
        return [...prev, ...cur];
    }, []);
}